import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2690f5ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex gap-[8px] h-[20px] items-center flex-nowrap" }
const _hoisted_2 = { class: "font-gordita-regular whitespace-nowrap flex items-center" }
const _hoisted_3 = { class: "dropdown-text font-gordita-medium max-w-[120px] text-ellipsis overflow-hidden" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  "data-testid": "initiators-dropdown",
  class: "uil uil-angle-down !text-[20px] ml-[2px] !mr-0"
}, null, -1))

import { IncrediButton, IncrediItem, IncrediList, IncrediMenu } from 'incredi-ui';
import { ref } from 'vue';
import { INITIATOR_TYPES } from '@/components/status-bar/components/CONST';


export default /*#__PURE__*/_defineComponent({
  __name: 'InitiatorsDropDown',
  props: {
    initiatorType: null,
    initiatorLicenseTypesList: null
  },
  emits: ["updateInitiatorLicenseType"],
  setup(__props: any, { emit }: { emit: ({ (e: 'updateInitiatorLicenseType', value: string): void }), expose: any, slots: any, attrs: any }) {




const menu = ref(false);
const selectedOption = ref(INITIATOR_TYPES.All);
const updateSelectOption = (option: string) => {
  selectedOption.value = option;
  emit('updateInitiatorLicenseType', option);
  menu.value = false;
};

return (_ctx: any,_cache: any) => {
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_unref(IncrediMenu), {
    modelValue: menu.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((menu).value = $event)),
    direction: "bottom-sticky-left",
    "offset-y": 4,
    "fill-width": ""
  }, {
    content: _withCtx(() => [
      _createVNode(_unref(IncrediList), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.initiatorLicenseTypesList, (option, index) => {
            return _withDirectives((_openBlock(), _createBlock(_unref(IncrediItem), {
              key: index,
              dense: "",
              clickable: "",
              class: _normalizeClass(["users-table-quick-filter-item", { 'users-table-quick-filter-item-selected font-gordita-medium': selectedOption.value === option }]),
              onClick: ($event: any) => (updateSelectOption(option))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(option) + " " + _toDisplayString(__props.initiatorType), 1)
              ]),
              _: 2
            }, 1032, ["class", "onClick"])), [
              [_directive_close_popup]
            ])
          }), 128))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(IncrediButton), {
        selected: menu.value,
        design: "master",
        class: "flex !px-[4px] !h-[20px] m-[-4px]",
        size: "small"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(selectedOption.value) + " " + _toDisplayString(__props.initiatorType), 1),
              _hoisted_4
            ])
          ])
        ]),
        _: 1
      }, 8, ["selected"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})